import { data } from '../../svg/ArrowRight/data';
import { makeIcon } from '../makeIcon';

export const ArrowRight = makeIcon(data, 'arrow_right', 'ArrowRight');

export default ArrowRight;
